import { useQuery } from '@tanstack/react-query'
import {
  fetchPopularMovies,
  fetchPopularCharacters,
  fetchSuggested,
  fetchSuggestedForFaceSwap,
  fetchRemixTools
} from '../api/listApi'
import { QUERY_KEY } from '../utils/constants'

export const useMovies = (params = {}, options = {}) => {
  return useQuery({
    queryKey: [QUERY_KEY.GetPopularMovies],
    queryFn: async () => {
      const resp = await fetchPopularMovies()
      return resp
    },
    enabled: false,
    ...options
  })
}

export const useCharacters = (params = {}, options = {}) => {
  return useQuery({
    queryKey: [QUERY_KEY.GetPopularCharacters],
    queryFn: async () => {
      const resp = await fetchPopularCharacters()
      return resp
    },
    enabled: false,
    ...options
  })
}

export const useSuggested = ({ isFaceSwap = false } = {}, options = {}) => {
  return useQuery({
    queryKey: [QUERY_KEY.GetSuggestedRail, isFaceSwap ? 'face_swap' : 'default'],
    queryFn: async () => {
      const resp = isFaceSwap
        ? await fetchSuggestedForFaceSwap()
        : await fetchSuggested()
      return resp
    },
    enabled: false,
    ...options
  })
}

export const useRemixTools = (type,params = {}, options = {}) => {
  return useQuery({
    queryKey: ['REMIX_TOOLS',type],
    queryFn: async () => {
      const resp = await fetchRemixTools(type)
      return resp
    },
    enabled: !!type,
    staleTime:60 * 1000,
    cacheTime:5 * 60 * 1000,
    ...options
  })
}
